import { useLocation } from "react-router-dom";

function useQuery<T = {}>() {
    const location = useLocation<T>();
    const t = new URLSearchParams(location.search.slice(1));
    let res = {};
    for(let [key, value] of t){
        res[key] = value;
    }

    return res as T;
}

export default useQuery;
